/**
 * Stormwrack navigation DCs.
 *
 * The on-course table below is straight from Stormwrack's rules for staying on
 * course: the pilot makes one Knowledge (geography) check per day, against a DC
 * set by what is in sight and what the weather is doing.
 */

export interface DCOption {
  label: string;
  value: number;
}

export const NAVIGATION_DC_OPTIONS: DCOption[] = [
  { label: 'Very familiar coast in sight', value: 5 },
  { label: 'Coast studied carefully in sight', value: 8 },
  { label: 'Coast seen once in sight', value: 13 },
  { label: 'Unknown coast in sight', value: 15 },
  { label: 'Open ocean, clear weather', value: 17 },
  { label: 'Open ocean, poor visibility', value: 25 },
  { label: 'Open ocean, stormy weather', value: 30 },
  { label: 'Open ocean, gale or hurricane', value: 40 }
];

/** Default DC for a fresh voyage: open ocean in clear weather. */
export const DEFAULT_NAVIGATION_DC = 17;
